import { SVGProps } from 'react';

export const NoVendorsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="130"
    height="130"
    viewBox="0 0 130 130"
    fill="none"
    {...props}
  >
    <circle cx="65" cy="65" r="65" fill="#01183F" fill-opacity="0.1" />
    <circle cx="65" cy="65" r="56" fill="#01183F" fill-opacity="0.15" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.3949 43.8509H51.623L47.2093 59.3051H38.7712L45.3949 43.8509ZM68.1041 43.8509H71.9553L76.369 59.3051H68.1041V43.8509ZM53.6462 59.3051L58.06 43.8509H61.9112V59.3051H53.6462ZM91.2082 59.3051H82.7733L78.3596 43.8509H84.5876L91.2082 59.3051ZM61.9235 84.047H46.4693V71.6836H61.9235V84.047ZM98.749 61.1926L89.4764 39.5566C88.9912 38.4192 87.8723 37.6836 86.636 37.6836H43.364C42.1277 37.6836 41.0088 38.4192 40.5236 39.5566L31.251 61.1926C30.8399 62.1477 30.9388 63.2449 31.5106 64.1135C32.0824 64.982 33.053 65.5012 34.0915 65.5012H37.1823V90.2281C37.1823 91.9342 38.567 93.3189 40.2732 93.3189H71.1817V71.6829H83.5451V93.3189H89.7268C91.433 93.3189 92.8177 91.9342 92.8177 90.2281V65.5012H95.9085C96.947 65.5012 97.9176 64.982 98.4894 64.1135C99.0612 63.2449 99.1601 62.1477 98.749 61.1926Z"
      fill="currentColor"
    />
  </svg>
);
